import { Navbar, Container } from "react-bootstrap";

import logo from "./../../assets/mahalino-logo.svg";
import logoName from "./../../assets/mahalino-logo-name.svg";

const NavBar = ({ small }) => {
  return (
    <Navbar bg="light" style={{ zIndex: "3000" }}>
      <Container>
        <Navbar.Brand href="#home">
          <img
            alt=""
            src={logo}
            width={small ? "25" : "50"}
            className="d-inline-block align-center"
          />{" "}
          <img
            alt=""
            src={logoName}
            width={small ? "70" : "90"}
            className="d-inline-block align-center pt-2 mx-2"
          />{" "}
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default NavBar;
